import React from "react";

/**
 * Иконочная кнопка DS (canon-session 2026-07-24). ghost (прозрач→elevated
 * на hover) / solid (accent). Квадрат sm32/md40/lg48, скруглён в круг.
 */
export function IconButton({
  icon,
  size = "md",
  variant = "ghost",
  label,
  className = "",
  ...rest
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: React.ReactNode;
  size?: "sm" | "md" | "lg";
  variant?: "ghost" | "solid";
  /** aria-label — обязателен для иконки без текста */
  label: string;
}) {
  const dim = size === "sm" ? "w-8 h-8" : size === "lg" ? "w-12 h-12" : "w-10 h-10";
  const variantCls =
    variant === "solid"
      ? "bg-accent hover:bg-accent-hover text-white"
      : "bg-transparent hover:bg-bg-elevated text-text-secondary";

  return (
    <button
      type="button"
      aria-label={label}
      {...rest}
      className={`${dim} ${variantCls} rounded-full inline-flex items-center justify-center press-scale ${className}`}
    >
      {icon}
    </button>
  );
}
